/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useMemo } from 'react';
import { Avatar, Box, Typography } from '@saviynt/design-system';

import { type User } from '../../../../services/types';
import { isEmpty, useInvertedLocalize } from '../../../../utils';
import invertedMessages from '../messages';

import './UserCard.css';

export interface UserCardProps {
  user: User;
}

function UserCard({ user }: UserCardProps) {
  const l = useInvertedLocalize(invertedMessages);

  const statusKey = useMemo(() => {
    switch (user.statuskey) {
      case 1:
        return l('Active');
      case 0:
        return l('Inactive');
      case 7:
        return l(`Suspended From Import Service`);
      default:
        return '-';
    }
  }, [user.statuskey, l]);

  return (
    <Box className='Ext-UserCard' data-testid='Ext-UserCard'>
      <Avatar size='small' />
      <div>
        <Typography kind='body3' color='--color-foreground-secondary-bold'>
          {l('User Name')}
        </Typography>
        <Typography
          kind='h3'
          lineLimit={1}
          color='--color-foreground-secondary-bold'>
          {user.username}
        </Typography>
      </div>
      <div>
        <Typography kind='body3' color='--color-foreground-neutral-subtle'>
          {l('First Name')}
        </Typography>
        <Typography
          kind='body2'
          color='--color-foreground-secondary-bold'
          lineLimit={1}>
          {isEmpty(user.firstname) ? '-' : user.firstname}
        </Typography>
      </div>
      <div>
        <Typography kind='body3' color='--color-foreground-neutral-subtle'>
          {l('Last Name')}
        </Typography>
        <Typography
          kind='body2'
          color='--color-foreground-secondary-bold'
          lineLimit={1}>
          {isEmpty(user.lastname) ? '-' : user.lastname}
        </Typography>
      </div>
      <div>
        <Typography kind='body3' color='--color-foreground-neutral-subtle'>
          {l('Email')}
        </Typography>
        <Typography
          kind='body2'
          color='--color-foreground-secondary-bold'
          lineLimit={1}>
          {isEmpty(user.email) ? '-' : user.email}
        </Typography>
      </div>
      <div>
        <Typography kind='body3' color='--color-foreground-neutral-subtle'>
          {l('Status')}
        </Typography>
        <Typography
          kind='body2'
          color='--color-foreground-secondary-bold'
          lineLimit={1}>
          {statusKey}
        </Typography>
      </div>
    </Box>
  );
}

export default UserCard;
